import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import SearchBar from '../SearchBar/SearchBar';
import { getFullPoemId, getAllCatalogs } from '../../services/poetryService';
import { useSearch } from '../../hooks/useSearch';

const SearchResults: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const query = searchParams.get('q') || '';

  const { results, isSearching } = useSearch(query);
  const catalogs = getAllCatalogs();

  const handleSearchChange = (newQuery: string) => {
    if (newQuery) {
      setSearchParams({ q: newQuery });
    } else {
      setSearchParams({});
    }
  };

  const hasResults = results.catalogs.length > 0 ||
                     results.poets.length > 0 ||
                     results.poems.length > 0;

  return (
    <div className="search-results catalog-list">
      <h1 className="catalog-list__title">Претрага</h1>

      <div style={{ marginBottom: '2rem' }}>
        <SearchBar value={query} onChange={handleSearchChange} autoFocus />
      </div>

      {!query && (
        <div className="search-results__empty">Унесите појам за претрагу</div>
      )}

      {query && isSearching && (
        <div className="search-results__empty">Претражујем…</div>
      )}

      {query && !isSearching && !hasResults && (
        <div className="search-results__empty">Нема резултата за "{query}"</div>
      )}

      {results.catalogs.length > 0 && (
        <section className="search-results__section">
          <h2 className="search-results__section-title">Каталози</h2>
          <ul className="catalog-list__items">
            {results.catalogs.map(catalog => (
              <li key={catalog.id}>
                <Link to={`/catalog/${catalog.id}`} className="catalog-list__item">
                  {catalog.name}
                </Link>
              </li>
            ))}
          </ul>
        </section>
      )}

      {results.poets.length > 0 && (
        <section className="search-results__section">
          <h2 className="search-results__section-title">Песници</h2>
          <ul className="catalog-list__items">
            {results.poets.map(({ poet, catalog }) => (
              <li key={poet.id}>
                <Link to={`/poet/${poet.id}`} className="catalog-list__item">
                  {poet.name}
                  <span className="catalog-list__item-count">({catalog.name})</span>
                </Link>
              </li>
            ))}
          </ul>
        </section>
      )}

      {results.poems.length > 0 && (
        <section className="search-results__section">
          <h2 className="search-results__section-title">Песме</h2>
          <ul className="catalog-list__items">
            {results.poems.map(({ poem, poet }) => (
              <li key={getFullPoemId(poet.id, poem.id)}>
                <Link to={`/poem/${getFullPoemId(poet.id, poem.id)}`} className="catalog-list__item">
                  {poem.name}
                  <span className="catalog-list__item-count">- {poet.name}</span>
                </Link>
              </li>
            ))}
          </ul>
        </section>
      )}

      <section className="search-results__section">
        <h2 className="search-results__section-title">Прегледај каталоге</h2>
        <ul className="catalog-list__items">
          {catalogs.map(catalog => (
            <li key={catalog.id}>
              <Link to={`/catalog/${catalog.id}`} className="catalog-list__item">
                {catalog.name}
                <span className="catalog-list__item-count">
                  ({catalog.poets.length} {catalog.poets.length === 1 ? 'песник' : 'песника'})
                </span>
              </Link>
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
};

export default SearchResults;

